module.exports = __webpack_public_path__ + "static/miis-bg-c1d6783411386fd451758895c482fa9d.png";